import {
	ILanguageSelector,
	LANGUAGE_LOCAL_NAME,
	LanguageEnum
}                    from '@models/language';
import { EnumUtils } from '@utils/helpers';

interface ILanguageConfig {
	supportedLanguages: LanguageEnum[];
	supportedLanguagesSelectorItems: ILanguageSelector[];
	languagesPath: string;
	languagesOverridePath: string;
}

const languageBasePath = `./assets/i18n/`;

function getSupportedLanguagesSelectorItems(): ILanguageSelector[] {
	const languageList = EnumUtils.getEnumsValuesAsList( LanguageEnum ) as LanguageEnum[];

	const supportedLanguages = [];
	languageList.forEach( ( language: LanguageEnum ) => {
		const languageSelector: ILanguageSelector = {
			shortCode: language,
			localName: LANGUAGE_LOCAL_NAME[ language ],
			flag: language
		};

		supportedLanguages.push( languageSelector );
	} );

	return supportedLanguages;
}

export const LANGUAGE_CONFIG: ILanguageConfig = {
	supportedLanguages: EnumUtils.getEnumsValuesAsList( LanguageEnum ) as LanguageEnum[],
	supportedLanguagesSelectorItems: getSupportedLanguagesSelectorItems(),
	languagesPath: `${ languageBasePath }lang/`,
	languagesOverridePath: `${ languageBasePath }lang_overrides/`
};
